// @flow

import React, { PureComponent } from "react";
import type { MapSearchContainerState } from "../types";
import SearchInput from "../SearchInput";
import MapContainer from "../MapContainer";
import ResultsListContainer from "../ResultsListContainer";
import apiFetch from "../../utils/_apiFetch.js";

export const MapSearchContext = React.createContext<MapSearchContainerState>({
  markers: [],
  translations: {},
  filters: {},
  setFilters: () => {},
});

class MapSearchContainer extends PureComponent<{}, MapSearchContainerState> {
  constructor(props) {
    super(props);

    this.setFilters = ({ name, value }) => {
      const portalUrl = document.body
        ? document.body.getAttribute("data-portal-url") || ""
        : "";
      let { filters } = this.state;
      if (value.length > 0) {
        filters[name] = value;
      } else {
        if (filters.hasOwnProperty(name)) {
          delete filters[name];
        }
      }
      let params = {
        portal_type: "Venue",
        metadata_fields: ["latitude", "longitude", "country", "city"],
        b_size: 100,
      };
      if (Object.keys(filters).length !== 0) {
        params = { ...params, ...filters };
      }
      if (params.SearchableText) {
        params.SearchableText = params.SearchableText + "*";
      }

      const fetches = [
        apiFetch({
          url: portalUrl + "/@search",
          params,
          method: "GET",
          restApi: true,
        }),
      ];

      Promise.all(fetches).then(([searchResults]) => {
        this.setState({
          ...this.state,
          filters,
          markers: searchResults?.items,
        });
      });
    };
    this.state = {
      markers: [],
      translations: props.translations,
      filters: {},
      setFilters: this.setFilters,
    };
  }

  componentDidMount() {
    const portalUrl = document.body
      ? document.body.getAttribute("data-portal-url") || ""
      : "";
    const fetches = [
      apiFetch({
        url: portalUrl + "/@search",
        params: {
          portal_type: "Venue",
          metadata_fields: ["latitude", "longitude", "country", "city"],
          b_size: 100,
        },
        method: "GET",
        restApi: true,
      }),
    ];
    Promise.all(fetches).then((data) => {
      const searchResults = data[0];

      this.setState({
        ...this.state,
        markers: searchResults.items,
      });
    });
  }

  render() {
    return (
      <MapSearchContext.Provider value={this.state}>
        <div className="map-search">
          <SearchInput />

          <MapContainer markers={this.state.markers} />
          <ResultsListContainer />
        </div>
      </MapSearchContext.Provider>
    );
  }
}

export default MapSearchContainer;
